var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 9.05V6H8.75V9.05C8.75 9.16046 8.83954 9.25 8.95 9.25H13.8C13.9105 9.25 14 9.16046 14 9.05V7H15V6C15 5.44772 14.5523 5 14 5H12H11.5002C11.814 4.58217 12 4.0628 12 3.5V3.375C12 2.06332 10.9367 1 9.625 1C8.99639 1 8.42483 1.24421 8 1.64294C7.57517 1.24421 7.00361 1 6.375 1C5.06332 1 4 2.06332 4 3.375V3.5C4 4.0628 4.18597 4.58217 4.49982 5H4H2C1.44772 5 1 5.44772 1 6V7H2V9.05C2 9.16046 2.08954 9.25 2.2 9.25H7.05C7.16046 9.25 7.25 9.16046 7.25 9.05ZM5.5 3.375C5.5 2.89175 5.89175 2.5 6.375 2.5C6.85825 2.5 7.25 2.89175 7.25 3.375V4.5H6.5C5.94772 4.5 5.5 4.05228 5.5 3.5V3.375ZM8.75 4.5H9.5C10.0523 4.5 10.5 4.05228 10.5 3.5V3.375C10.5 2.89175 10.1082 2.5 9.625 2.5C9.14175 2.5 8.75 2.89175 8.75 3.375V4.5ZM13.8 10.75C13.9105 10.75 14 10.8395 14 10.95V13C14 14.1046 13.1046 15 12 15H8.75V10.95C8.75 10.8395 8.83954 10.75 8.95 10.75H13.8ZM7.25 10.95V15H4C2.89543 15 2 14.1046 2 13V10.95C2 10.8395 2.08954 10.75 2.2 10.75H7.05C7.16046 10.75 7.25 10.8395 7.25 10.95Z",
    fill: "#8178EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGift);
export default __webpack_public_path__ + "static/media/ImgGift.12d7e16c07d58b87bb96234da07cf786.svg";
export { ForwardRef as ReactComponent };